import DiscountDescription from 'components/display/DiscountDescription'
import React from 'react'
import styled from 'styled-components'

import { DaysAvailabilities } from './types'

type DiscountProps = { discount?: DaysAvailabilities[string]['discount'] }

const DiscountIndicator = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme?.['-ds-core-400']?.value};
`

const DISCOUNT_DESCRIPTION_ID = 'discount'

const DiscountAvailableWrapper = styled.div`
  margin-bottom: 10px;
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};

  ${DiscountIndicator} {
    display: inline-block;
    margin: 0 0.4em 0.1em 0;
  }
`

export const DiscountMarker = styled(DiscountIndicator).attrs({
  role: 'doc-noteref',
  'aria-describedby': DISCOUNT_DESCRIPTION_ID,
})``

export function DiscountAvailable({ discount }: DiscountProps) {
  return (
    <DiscountAvailableWrapper id={DISCOUNT_DESCRIPTION_ID}>
      <DiscountIndicator />
      {discount ? (
        <DiscountDescription short discount={discount} />
      ) : (
        <>Select dates to see discount amount</>
      )}
    </DiscountAvailableWrapper>
  )
}
